import Row from 'react-bootstrap/Row'
import { PRIZE_CONFIG, PRIZE_SOURCE } from '../../../constants/prizes'
import HeadTitle from './HeadTitle'
import { useState, Fragment, useEffect } from 'react'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Container from 'react-bootstrap/Container'
import Modal from 'react-bootstrap/Modal'

let intIdInput = 0

const PrizeItem = ({ index, prizeType, resultPrize, sanookResult, updateDraftResult, updateResult }) => {
  const thisIntId = intIdInput++
  const thisId = `preprize-item-input-${thisIntId}`
  const nextId = `preprize-item-input-${thisIntId + 1}`
  const [input, setInput] = useState(resultPrize)
  const [isShowModal, setIsShowModal] = useState(false)
  const [manualInput, setManualInput] = useState(resultPrize)
  const [sanookInput, setSanookInput] = useState(sanookResult)
  const tmpInput = resultPrize.toString()
  const isConflictResult = sanookResult && resultPrize !== sanookResult
  const focusNextInput = () => {
    const nexInput = document.getElementById(nextId)
    if (nexInput) {
      nexInput.focus()
    }
  }

  useEffect(() => {
    if (sanookResult) {
      setSanookInput(sanookResult)
    }

    if (resultPrize) {
      setInput(resultPrize)
      setManualInput(resultPrize)
    }
  }, [resultPrize, sanookResult])

  return (
    <Col key={index} className="mt-2 mb-2" sm={3}>
      <Form.Control
        type="text"
        id={thisId}
        disabled={resultPrize && !isConflictResult ? true : false}
        readOnly={isConflictResult ? true : false}
        maxLength={PRIZE_CONFIG[prizeType].maxLength}
        minLength={PRIZE_CONFIG[prizeType].maxLength}
        placeholder={`${PRIZE_CONFIG[prizeType].maxLength} หลัก ${
          prizeType === 'first' ? '' : `ลำดับที่ ${index + 1}`
        }`}
        className={`text-center ${isConflictResult ? 'bg-danger text-white' : resultPrize ? 'text-success' : ''}`}
        onKeyDown={async (e) => {
          if (e.key === 'Enter' && e.target.value.length === PRIZE_CONFIG[prizeType].maxLength) {
            updateDraftResult(prizeType, index, input)
            focusNextInput()
          }
        }}
        onBlur={async () => {
          if (!resultPrize && input.length === PRIZE_CONFIG[prizeType].maxLength) {
            updateDraftResult(prizeType, index, input)
          }
        }}
        onChange={(e) => {
          setInput(e.target.value.replace(/[^0-9]/g, ''))
        }}
        onClick={() => {
          if (isConflictResult) {
            setIsShowModal(true)
          }
        }}
        value={tmpInput ? tmpInput : input}
      />
      <Modal show={isShowModal} onHide={() => setIsShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>แก้ไขผลรางวัล</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="text-center">
            <Row className="mb-2 text-black" style={{ fontSize: '1.5rem' }}>
              <Col>Manual</Col>
              <Col>Sanook</Col>
            </Row>
            <Row>
              <Col className="mt-2">
                <Form.Control
                  type="text"
                  className="text-center"
                  maxLength={PRIZE_CONFIG[prizeType].maxLength}
                  minLength={PRIZE_CONFIG[prizeType].maxLength}
                  onChange={(e) => setManualInput(e.target.value.replace(/[^0-9]/g, ''))}
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter' && e.target.value.length === PRIZE_CONFIG[prizeType].maxLength) {
                      updateResult(prizeType, PRIZE_SOURCE.MANUAL, index, manualInput)
                      setIsShowModal(false)
                    }
                  }}
                  value={manualInput}
                />
              </Col>
              <Col className="mt-2">
                <Form.Control
                  type="text"
                  className="text-center"
                  maxLength={PRIZE_CONFIG[prizeType].maxLength}
                  minLength={PRIZE_CONFIG[prizeType].maxLength}
                  onChange={(e) => setSanookInput(e.target.value.replace(/[^0-9]/g, ''))}
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter' && e.target.value.length === PRIZE_CONFIG[prizeType].maxLength) {
                      updateResult(prizeType, PRIZE_SOURCE.SANOOK, index, sanookInput)
                      setIsShowModal(false)
                    }
                  }}
                  value={sanookInput}
                />
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Col>
  )
}

const PrizeItems = ({ prizeType, result = {}, sanookResult = {}, updateDraftResult, updateResult }) => {
  let listInput = []
  const prizeText = PRIZE_CONFIG[prizeType].thaiText
  for (let i = 0; i < result.length; i++) {
    listInput.push(
      <PrizeItem
        key={prizeText + i}
        prizeType={prizeType}
        index={i}
        resultPrize={result[i]}
        sanookResult={sanookResult ? sanookResult[i] : null}
        updateDraftResult={updateDraftResult}
        updateResult={updateResult}
      />,
    )
  }
  return (
    <Fragment>
      <HeadTitle title={prizeText} discription="" />
      <Row className="d-flex justify-content-center">{listInput}</Row>
    </Fragment>
  )
}

export default PrizeItems
